import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/account")({
	component: AccountLayoutPage,
	ssr: false,
});

function AccountLayoutPage() {
	return <Outlet />;
}
